// extracted by mini-css-extract-plugin
export default {"calendar_wrapper":"Ct","modify_order":"Et","modify_order_header":"Ft","product_details_form_wrapper":"Gt","c_wrapper":"Ht","save_button":"It","title":"Jt","modify_order_title_wrapper":"Kt","note":"Lt","buttons_wrapper":"Mt"};
    if(module.hot) {
      // 1715188229760
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  